"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import Link from "next/link";
import { useAppSelector } from "@/store/hooks";

const JoinUs = () => {
  const { data: content } = useAppSelector((state: any) => state.content);
  const data = content?.joinUs;

  return (
    <section
      className="relative h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden bg-fixed bg-cover bg-center"
      style={{
        backgroundImage: data?.backgroundImage
          ? `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("${data.backgroundImage}")`
          : 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("/themes/royal-blue/cta-bg-chef.png")',
      }}
    >
      {/* Content Container */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-sacramento text-3xl md:text-4xl text-[#c59d5f] mb-4"
        >
          {data?.subtitle || "We Create Delicious Memories"}
        </motion.p>

        {/* Main Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-cormorant text-4xl md:text-6xl lg:text-[72px] text-white mb-6 font-bold leading-tight"
        >
          {data?.title || "Pull Up A Chair: Take A Taste & Come Join Us"}
        </motion.h2>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="text-[16px] md:text-[18px] text-white/80 mb-10 font-inter font-medium tracking-wide"
        >
          {data?.description ||
            "We have awesome recipes and the most talented chefs in town!"}
        </motion.p>

        {/* Bottom Actions */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="flex flex-col md:flex-row items-center justify-center gap-8"
        >
          <div className="flex flex-col items-center">
            <span className="font-sacramento text-4xl text-white">
              {data?.signature?.name || "John Peter"}
            </span>
            <span className="text-[11px] font-bold tracking-[0.2em] uppercase text-[#c59d5f] mt-1">
              {data?.signature?.role || "Master Chef"}
            </span>
          </div>

          <Link
            href={data?.button?.href || "#reservation"}
            target="_blank"
            className="bg-white text-[#1a1a1a] px-10 py-4 font-bold font-inter text-[14px] uppercase tracking-widest hover:bg-[#c59d5f] hover:text-white transition-all duration-300"
          >
            {data?.button?.label || "Book A Table"}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default JoinUs;
